export * from './card-detail.model';
